import { render, staticRenderFns } from "./OaLeftSidebar.vue?vue&type=template&id=5b960828&scoped=true&"
import script from "./OaLeftSidebar.vue?vue&type=script&lang=js&"
export * from "./OaLeftSidebar.vue?vue&type=script&lang=js&"
import style0 from "./OaLeftSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OaLeftSidebar.vue?vue&type=style&index=1&id=5b960828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b960828",
  null
  
)

export default component.exports